import TestIssueBody from './test_issue_body.vue';

export const components = {
  TestIssueBody,
};

export const componentNames = {
  TestIssueBody: TestIssueBody.name,
};
